<!DOCTYPE html>
<html lang="tr">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">

<title>Günlük — Moda Fotoğrafçılığı Üzerine Yazılar | Frawgraphy</title>
<meta name="description" content="Işık şemaları, sette çalışma düzeni, renk yönetimi ve yapay zekânın moda fotoğrafçılığındaki yeri üzerine Frawgraphy stüdyosunun notları.">
<meta name="robots" content="index, follow, max-image-preview:large">
<link rel="canonical" href="https://frawgraphy.com/blog.html">

<meta property="og:type" content="website">
<meta property="og:site_name" content="Frawgraphy">
<meta property="og:locale" content="tr_TR">
<meta property="og:url" content="https://frawgraphy.com/blog.html">
<meta property="og:title" content="Günlük — Moda Fotoğrafçılığı Üzerine Yazılar">
<meta property="og:description" content="Işık şemaları, sette çalışma düzeni ve renk yönetimi üzerine stüdyo notları.">
<meta property="og:image" content="https://frawgraphy.com/assets/img/hero.jpg">
<meta name="twitter:card" content="summary_large_image">

<link rel="icon" href="/favicon.ico" sizes="any">
<link rel="icon" type="image/png" sizes="32x32" href="/assets/img/favicon-32.png">
<link rel="icon" type="image/png" sizes="16x16" href="/assets/img/favicon-16.png">
<link rel="apple-touch-icon" sizes="180x180" href="/assets/img/apple-touch-icon.png">
<link rel="manifest" href="/site.webmanifest">

<meta name="theme-color" content="#060606" media="(prefers-color-scheme: dark)">
<meta name="theme-color" content="#f5f3f0" media="(prefers-color-scheme: light)">

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;0,6..96,700;0,6..96,900;1,6..96,400;1,6..96,700&family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500&display=swap">
<link rel="stylesheet" href="assets/css/style.css?v=20260920b">
<noscript><style>.reveal{opacity:1;transform:none}</style></noscript>

<script>
  (function () {
    try {
      var t = localStorage.getItem('frawgraphy-theme');
      if (!t) t = matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', t);
      document.documentElement.setAttribute('data-lang', localStorage.getItem('frawgraphy-lang') || 'tr');
    } catch (e) {
      document.documentElement.setAttribute('data-theme', 'dark');
      document.documentElement.setAttribute('data-lang', 'tr');
    }
  })();
</script>

<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "Blog",
  "@id": "https://frawgraphy.com/blog.html#blog",
  "name": "Frawgraphy Günlük",
  "description": "Moda fotoğrafçılığı, ışık ve set düzeni üzerine stüdyo notları.",
  "inLanguage": "tr-TR",
  "publisher": { "@type": "Organization", "name": "Frawgraphy Studio", "url": "https://frawgraphy.com/" },
  "blogPost": [
    { "@type": "BlogPosting", "headline": "Tek ışıkla editorial: sert kaynağın grameri",
      "url": "https://frawgraphy.com/blog/tek-isikla-editorial.html", "datePublished": "2026-06-18", "author": { "@type": "Organization", "name": "Frawgraphy Studio" } },
    { "@type": "BlogPosting", "headline": "Çekim öncesi: iyi bir referans seti nasıl kurulur",
      "url": "https://frawgraphy.com/blog/cekim-oncesi-referans-seti.html", "datePublished": "2026-05-02", "author": { "@type": "Organization", "name": "Frawgraphy Studio" } },
    { "@type": "BlogPosting", "headline": "Yapay zekâ sete girdiğinde: neyi üretiyoruz, neyi çekiyoruz",
      "url": "https://frawgraphy.com/blog/yapay-zeka-ve-set.html", "datePublished": "2026-03-24", "author": { "@type": "Organization", "name": "Frawgraphy Studio" } },
    { "@type": "BlogPosting", "headline": "Siyah beyaza çevirmeden önce renkte ne yapmalı",
      "url": "https://frawgraphy.com/blog/siyah-beyaz-donusum.html", "datePublished": "2026-01-15", "author": { "@type": "Organization", "name": "Frawgraphy Studio" } }
  ]
}
</script>
</head>
<body data-title-key="blog.docTitle">

<a class="skip-link" href="#main" data-i18n="skip">İçeriğe geç</a>

{{> header }}

{{> menu }}

<main id="main" class="page">
  <div class="shell">

    <nav class="crumbs" aria-label="Site yolu">
      <ol>
        <li><a href="index.html" data-i18n="blog.crumbHome">Ana sayfa</a></li>
        <li aria-current="page" data-i18n="blog.crumbBlog">Günlük</li>
      </ol>
    </nav>

{{{ pageHead }}}

    <ul class="posts">
{{#each posts}}
      <li class="post reveal">
        <a href="blog/{{ slug }}.html">
          <span class="post-media">
            <img src="{{ cover.listUrl }}" alt="{{ cover.listAlt }}" width="{{ cover.listW }}" height="{{ cover.listH }}" loading="lazy" decoding="async">
          </span>
          <span class="post-body">
            <span class="post-meta">
              <span class="card-cat" data-i18n="{{ i18n }}.cat">{{ category }}</span>
              <time datetime="{{ date }}">{{ dateText }}</time>
              <span class="post-read" data-read="{{ @n }}">{{ readMinutes }} dk</span>
            </span>
            <h2 class="post-title" data-i18n="{{ i18n }}.title">{{ title }}</h2>
            <p class="post-excerpt" data-i18n="{{ i18n }}.excerpt">
              {{ excerpt }}
            </p>
          </span>
        </a>
      </li>
{{/each}}
    </ul>

    <aside class="page-cta reveal">
      <h2 data-i18n="blog.cta.title">Bir proje mi var?</h2>
      <p data-i18n="blog.cta.text">Takvimimiz iki ay önceden dolar. Tarih ve kapsamı yazmanız yeterli.</p>
      <a class="btn btn--primary" href="index.html#contact">
        <span data-i18n="blog.cta.btn">Çekim planla</span>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
      </a>
    </aside>
  </div>
</main>

{{> footer }}

<script src="assets/js/i18n.js?v=20260920b" defer></script>
<script src="assets/js/main.js?v=20260920b" defer></script>
</body>
</html>
